import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';

import { InSubject } from '@atmi/core/utils';

import { BehaviorSubject, combineLatest, Subject } from 'rxjs';

import { takeUntil } from 'rxjs/operators';

import {  isArrayNotEmpty, isNotNullOrUndefined } from '@atmi/core/utils/operators';

import { AllowedOperation, ClassName } from '@sim/role/models/role';
import { RoleService } from '@sim/role/services/role.service';
import { checkIsAllow } from '@sim/role/utils';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[roleVisibility]'
})
export class RoleDirective implements OnDestroy {

  @Input('roleVisibility') @InSubject() allowedOperations: AllowedOperation = [];
  readonly allowedOperationsChange = new BehaviorSubject<AllowedOperation>([]);

  @Input() @InSubject() roleVisibilityClassNames?: ClassName[];
  readonly roleVisibilityClassNamesChange = new BehaviorSubject<ClassName[]>([]);

  @Input() @InSubject() roleVisibilityBehaviour?: 'hide' | 'show';
  readonly roleVisibilityBehaviourChange = new BehaviorSubject<'hide' | 'show'>('hide');

  private readonly onDestroy$ = new Subject();

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly roleService: RoleService,
  ) {
    combineLatest([
      this.roleService.role$,
      this.allowedOperationsChange.pipe(isArrayNotEmpty()),
      this.roleVisibilityClassNamesChange.pipe(isNotNullOrUndefined()),
      this.roleVisibilityBehaviourChange.pipe(isNotNullOrUndefined()),
    ]).pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(([userRole, allowedOperations, classNames, behaviour]) => {
      let isAllow = false;
      if (!userRole) {
        isAllow = false;
      } else {
        isAllow = (classNames || []).some((cn) => checkIsAllow(userRole, allowedOperations as AllowedOperation, cn));
      }

      if (behaviour === 'hide') {
        if (isAllow) {
          // If condition is true add template to DOM
          this.viewContainer.clear();
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          // Else remove template from DOM
          this.viewContainer.clear();
        }
      } else if (behaviour === 'show') {
        if (isAllow) {
          // If condition is true add template to DOM
          this.viewContainer.clear();
        } else {
          // Else remove template from DOM
          this.viewContainer.clear();
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

}
